export default __webpack_public_path__ + "static/media/facebook.5e1cb4b8.svg";